<!-- mobile -->
<section class="md:hidden max-w-sm mx-auto">
  <section class="px-3 py-5">
    <ng-container *ngIf="hideStepper | async">
      <ul>
        <li
          *ngFor="let item of megaMenu; let index = index"
          (click)="changeMegaMenuMobileStep(index)"
          class="py-3 font-bold flex items-center cursor-pointer"
        >
          {{ item.title }}
          <svg
            width="14"
            height="22"
            class="icon-bytesize text-red-500 ml-auto"
          >
            <use
              stroke-width="4px"
              attr.xlink:href="{{ '#i-chevron-right' | bytesizeIcon }}"
            ></use>
          </svg>
        </li>
      </ul>
    </ng-container>

    <mat-stepper
      class="stepper-megamenu"
      #megaMenuMobileStepper
    >
      <mat-step *ngFor="let item of megaMenu">
        <div [ngClass]="{ hidden: hideStepper | async }">
          <portal-ui-mega-menu-mobile
            [menuTitle]="item.title"
            [menuItems]="item.menu"
            (resetStep)="resetMegaMenuMobileStep()"
          ></portal-ui-mega-menu-mobile>
        </div>
      </mat-step>
    </mat-stepper>
  </section>
</section>

<!-- desktop -->
<section class="max-w-7xl h-full mx-auto hidden md:flex">
  <nav
    *ngFor="let item of megaMenu"
    class="nav-megamenu"
  >
    <mat-icon
      class="!size-14 mb-5"
      [svgIcon]="item.icon"
    ></mat-icon>
    <p class="h-12 mb-4 font-bold">{{ item.title }}</p>
    <portal-ui-mega-menu-item [menuItems]="item.menu"></portal-ui-mega-menu-item>
  </nav>
</section>
